import src from "IMAGE";
export default { src, width: 200, height: 39, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AElJSWgoKChOEBAQcw4ODmQNDQ1fCgoKTgsLC08PDw9uAFhYWIssLCxoFRUVmxUVFZoVFRWaExMTkhEREX8WFhanjn4MqQ0ms/sAAAAASUVORK5CYII="};
